module.exports = __webpack_public_path__ + "img/Screenshot-11.ab4856c8.png";